import {
  LOAD_ORDER_STATUS,
  REMOVE_ALL_ORDER_STATUS,
  REMOVE_ORDER_STATUS,
  OPEN_FEEDBACK_MODAL,
  CLOSE_FEEDBACK_MODAL,
  SEND_REVIEW_SUCCESS,
  SEND_REVIEW_REQUEST,
  SEND_REVIEW_FAILURE,
} from './orderStatusTypes';
import api from '../../api';
import {createAlert} from '../Alert/alertActions';

export function loadOrderStatus(orderStatus) {
  return function(dispatch) {
    dispatch({type: LOAD_ORDER_STATUS, orderStatus});
  };
}

export function removeOrderStatus(orderStatus) {
  return function(dispatch) {
    dispatch({type: REMOVE_ORDER_STATUS, orderStatus});
  };
}

export function removeAllOrderStatus() {
  return function(dispatch) {
    dispatch({type: REMOVE_ALL_ORDER_STATUS});
  };
}

export function sendReview(orderId, {comment, rating}) {
  return function(dispatch) {
    dispatch({type: SEND_REVIEW_REQUEST});

    let body = {order_id: orderId, rating};
    if (comment) {
      body = {...body, comment};
    }
    api
      .post(`/reviews`, body)
      .then(response => {
        dispatch({type: SEND_REVIEW_SUCCESS});
        dispatch(
          createAlert({
            type: 'success',
            message: 'Your review has been sent. We appreciate your feedback!',
          })
        );
      })
      .catch(error => {
        dispatch({type: SEND_REVIEW_FAILURE});
      });
  };
}

export function openFeedbackModal() {
  return function(dispatch) {
    dispatch({type: OPEN_FEEDBACK_MODAL});
  };
}

export function closeFeedbackModal() {
  return function(dispatch) {
    dispatch({type: CLOSE_FEEDBACK_MODAL});
  };
}
